<script>
export default {
  name: 'EmptyRouterView'
}
</script>
<template>
    <router-view/>
</template>
